import React, { useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import PhotoOutlined from '@mui/icons-material/PhotoOutlined';
import * as S from './LogPhotoLargePanel.styled';

/** RightBar large viewer for a work-order / form photo from the photos table. */
const LogPhotoLargePanel = ({
  title = 'Photo',
  src,
}: {
  title?: string
  src: string
}) => {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);

  return (
    <S.Container>
      <S.Header>
        <S.HeaderIcon>
          <PhotoOutlined fontSize="small" />
        </S.HeaderIcon>
        <S.HeaderText>
          <S.Title>{title}</S.Title>
          <S.Sub>Form photo</S.Sub>
        </S.HeaderText>
      </S.Header>
      <S.Frame>
        {!loaded && !failed ? (
          <S.Loading aria-label="Loading photo">
            <CircularProgress size={28} thickness={4} sx={{ color: '#64748b' }} />
          </S.Loading>
        ) : null}
        {failed ? (
          <S.Hint>Preview unavailable for this photo.</S.Hint>
        ) : (
          <S.Img
            src={src}
            alt={title}
            onLoad={() => setLoaded(true)}
            onError={() => {
              setFailed(true);
              setLoaded(false);
            }}
          />
        )}
      </S.Frame>
    </S.Container>
  );
};

export default LogPhotoLargePanel;
